function getIDForColor(id) {
    var idNum = parseInt(id.toString().slice(-1));
    idNum = idNum % 9;
    const Styles = [
        {
            backgroundColor: "#e8dbff",
            color: "#420ba1"
        },
        {
            backgroundColor: "#f0ab09",
            color: "#ffffff"
        },
        {
            backgroundColor: "#f00909",
            color: "#ffffff"
        },
        {
            backgroundColor: "#dff009",
            color: "#000000"
        },
        {
            backgroundColor: "#0af009",
            color: "#ffffff"
        },
        {
            backgroundColor: "#e8dbff",
            color: "#420ba1"
        },
        {
            backgroundColor: "#0998f0",
            color: "#ffffff"
        },
        {
            backgroundColor: "#ff54d0",
            color: "#ffffff"
        },
        {
            backgroundColor: "#cccccc",
            color: "#1e1e1e"
        },
        {
            backgroundColor: "#d3fb0a",
            color: "#768d06"
        }
    ];
    return Styles[idNum];
}

function formatDateTime(sDate,FormatType) {
    var lDate = new Date(sDate)

    var month=new Array(12);
    month[0]="Ocak";
    month[1]="Şubat";
    month[2]="Mart";
    month[3]="Nisan";
    month[4]="Mayıs";
    month[5]="Haziran";
    month[6]="Temmuz";
    month[7]="Ağustos";
    month[8]="Eylül";
    month[9]="Ekim";
    month[10]="Kasım";
    month[11]="Aralık";

    var weekday=new Array(7);
    weekday[0]="Pazar";
    weekday[1]="Pazartesi";
    weekday[2]="Salı";
    weekday[3]="Çarşamba";
    weekday[4]="Perşembe";
    weekday[5]="Cuma";
    weekday[6]="Cumartesi";

    var hh = lDate.getHours() < 10 ? '0' + 
        lDate.getHours() : lDate.getHours();
    var mi = lDate.getMinutes() < 10 ? '0' + 
        lDate.getMinutes() : lDate.getMinutes();
    var ss = lDate.getSeconds() < 10 ? '0' + 
        lDate.getSeconds() : lDate.getSeconds();

    var d = lDate.getDate();
    var dd = d < 10 ? '0' + d : d;
    var yyyy = lDate.getFullYear();
    var mon = eval(lDate.getMonth()+1);
    var mm = (mon<10?'0'+mon:mon);
    var monthName=month[lDate.getMonth()];
    var weekdayName=weekday[lDate.getDay()];

    if(FormatType==0) {
       return dd+'.'+mm+'.'+yyyy;
    } else if(FormatType==1) {
       return mm+'/'+dd+'/'+yyyy+' '+hh+':'+mi;
    } else if(FormatType==2) {
       return weekdayName+', '+monthName+' '+ 
            dd +', ' + yyyy;
    } else if(FormatType==3) {
       return mm+'/'+dd+'/'+yyyy; 
    } else if(FormatType==4) {
       var dd1 = lDate.getDate();    
       return dd1+'-'+Left(monthName,3)+'-'+yyyy;    
    } else if(FormatType==5) {
        return mm+'/'+dd+'/'+yyyy+' '+hh+':'+mi+':'+ss;
    } else if(FormatType == 6) {
        return mon + '/' + d + '/' + yyyy + ' ' + 
            hh + ':' + mi + ':' + ss;
    } else if(FormatType == 7) {
        return  dd + '-' + monthName.substring(0,3) + 
            '-' + yyyy + ' ' + hh + ':' + mi + ':' + ss;
    }
}

function widgetCode(props) {
    return '<script>\n' +
        '    window.__hv = window.__hv || {};\n' +
        '    __hv.license = "'+props.license_number+'";\n' +
        '    __hv.url = "'+process.env.REACT_APP_WIDGET+'";\n' +
        '    (function() {\n' +
        '        var hv = document.createElement(\'script\'); hv.type = \'text/javascript\'; hv.async = true;\n' +
        '        var date = new Date();hv.src = window.__hv.url+\'dist/js/widget/react.app.js?\'+(""+date.getFullYear() + date.getMonth() + date.getDate());\n' +
        '        var s = document.getElementsByTagName(\'body\')[0]; s.parentNode.appendChild(hv, s);\n' +
        '    })();\n' +
        '</script>';

}

function firstLetterSub(text) {
    const mySentence = text;
    const words = mySentence.split(" ");

    return words.map((word) => {
        return word[0].toUpperCase().substring(0, 1)
    }).join("");

}

function firstLetterText(text) {
    const mySentence = text;
    const words = mySentence.split(" ");
	return text;
    return words.map((word) => {
        return word[0].toUpperCase() + word.substring(1);
    }).join(" ");

}
function urlify(text) {
    var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    return text.replace(urlRegex, function(url,b,c) {
        var url2 = (c == 'www.') ?  'http://' +url : url;
        return '<a href="' +url2+ '" target="_blank">' + url + '</a>';
    })
}
function messageReplace(message){
    if(message===null){
        return "";
    }
    var array = {
        "{{vote_agent_down}}":"<i class='fa fa-thumbs-down' style='color:red;'></i>",
        "{{vote_agent_up}}":"<i class='fa fa-thumbs-up' style='color:green;'></i>"
    }

    Object.keys(array).map((k)=>{
        message=message.replace(k,array[k]);
    });

    return message;

}

function unreadMessageCount(prop){
    var unreadMessage=0;
    Object.keys(prop.activeChats.filter(chat=>chat.status=='A' && chat.supervised!=1)).map(chat => {
        unreadMessage+=prop.activeChats.filter(chats=>chats.status=='A' && chats.supervised!=1)[chat].messages.filter(message=>message.read_agent_state==2 && (message.receiver==2 || message.receiver==3) && message.sender==1).length;
    });

    return unreadMessage;
}
function titleAddMessageCount(data = {}){
    var title=data.prop.document_title;
    if(typeof data.prop!=="undefined") {
        data.messageCount = unreadMessageCount(data.prop);
    }
    document.title = title + (data.messageCount>0 ? "("+data.messageCount+")" : "");
}


module.exports = {
    getIDForColor,
    firstLetterSub,
    firstLetterText,
    widgetCode,
	formatDateTime,
    messageReplace,
    titleAddMessageCount,
    urlify,
    unreadMessageCount
}
